import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { TabItem } from "src/app/core/models/TabItem";

@Component({
	selector: "app-tabs",
	templateUrl: "./tabs.component.html",
	styleUrl: "./tabs.component.scss",
})
export class TabsComponent {
	@Input() tabs: TabItem[];
	@Input() activeTabId: number = 1;
	@Input() bindLabel = "";
	@Input() bindValue = "";
	@Output() tabSelected = new EventEmitter<string>();

	onTabSelect(tabId: string) {
		this.tabSelected.emit(tabId);
	}
}
